module.exports = __webpack_public_path__ + "static/media/Butterfly.904384c9.png";